import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { LoaderComponent } from 'src/app/components/builders/loader/loader.component';
import { Data } from 'src/app/helper/datastore';
import { WebRequestService } from 'src/app/services/web-request.service';
import { EditViewSlideShowComponent } from 'src/app/components/common/edit-view-slide-show/edit-view-slide-show.component';
import { ActivatedRoute } from '@angular/router';
import { OldSlideShowComponent } from '../old-slide-show/old-slide-show.component';
import { TicketHistoryComponent } from '../../service-slide-show/ticket-history/ticket-history.component';

@Component({
  selector: 'app-my-profile-old',
  templateUrl: './my-profile-old.component.html',
  styleUrls: ['./my-profile-old.component.scss']
})
export class MyProfileOldComponent implements OnInit {

  @ViewChild('alertModal') alertModal: any;
  LoaderComponent: any = '';
  expanded: boolean = true;
  myProfileForm: FormGroup;
  multiDropdownSettings: any;
  applicationStatus: any[] = []
  marital: any[] = [];
  branchList: any[] = [];
  caste: any[] = [];
  owner: any[] = [];
  loginData: any;
  maxDate = new Date;
  dateTypeFrom: string = 'Website Login From';
  dateTypeTo: string = 'Website Login To';
  serviceType: any = [];
  motherTongue: any = [];
  viewType: number;
  myProfileReqObj: any;
  myProfiles: any [] = [];
  allMyProfiles: any[] = [];
  scrollDown: boolean;
  formValue: any;
  gridType2: any;
  totalFields: any[] = [];
  matchedHeaders: any[] = [];
  headers: any[] = [];
  loadedAllData: boolean;
  myProfile: boolean = true;
  confidentialGrades: any[] = [];
  confiGrade: boolean = false;
  educationCategories: any[] = [];
  noDataList: any[] = [];
  havingProfiles: any[] = [];
  enableDates: boolean;
  lastvalue: any;
  branchStrList: any[] = [];
  responseMessage: any
  myProfileGrid: boolean;
  aboutDataValues: any[];
  slideshowOrGrid:any;

  constructor(
    private fb: FormBuilder,
    public service: WebRequestService,
    private loginDataStore: Data,
    public dialog: MatDialog,
    private route: ActivatedRoute
  ) {
    this.viewType = 1;
    this.multiDropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      closeDropDownOnSelection: true,
    };

    this.serviceType = [{
      id: 601,
      value: "Regular"
    }, {
      id: 602,
      value: "Assisted"
    }, 
    // {
    //   id: 603,
    //   value: "Confidential"
    // },
    ];

    this.havingProfiles = [{
      id: 0,
      value: "Without Photo"
    }, {
      id: 1,
      value: "With Photo"
    }, 
    {
      id: 2,
      value: "With Horoscope"
    },
    {
      id: 3,
      value: "Without Horoscope"
    },
    {
      id: 4,
      value: "With SA Form"
    },
    {
      id: 5,
      value: "Without SA Form"
    },
    {
      id: 6,
      value: "Photo Protected"
    }
    ];

    this.loadForm();

   }

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      if (res) {
        this.myProfileForm.patchValue({
          profileID: res.id
        })
      }
    })
    this.loadBasicMasterData();
  }
  slideOrGrid(value){
    if(value == 'grid'){
      this.slideshowOrGrid = value;
    }else if(value == 'slide'){
      this.slideshowOrGrid = value
    }
}
  loadForm() {
    this.myProfileForm = this.fb.group({
      gender: new FormControl(0),
      typeOfProfile: new FormControl(null),
      profileID: new FormControl('', [Validators.pattern(/^[0-9\s]*$/)]),
      domacile: new FormControl(null),
      applicationStatus: new FormControl(''),
      marital: new FormControl(''),
      branch: new FormControl(''),
      caste: new FormControl(''),
      profileOwner: new FormControl(''),
      dateOfRegFrom: new FormControl(''),
      dateOfRegTo: new FormControl(''),
      assignedFrom: new FormControl(''),
      assignedTo: new FormControl(''),
      firstName: new FormControl('',[Validators.pattern('^[a-zA-Z ]*$')]),
      surName: new FormControl('',[Validators.pattern('^[a-zA-Z ]*$')]),
      fatherName: new FormControl('',[Validators.pattern('^[a-zA-Z ]*$')]),
      motherName: new FormControl('',[Validators.pattern('^[a-zA-Z ]*$')]),
      dateTypeLogin: new FormControl(null),
      dateLoginFrom: new FormControl(''),
      dateLoginTo: new FormControl(''),
      secondaryOwner: new FormControl(''),
      previousOwner: new FormControl(''),
      verifiedContacts: new FormControl(null),
      emailVerifiedContacts: new FormControl(null),
      websiteBlocked: new FormControl(null),
      highConfidential: new FormControl(''),
      nxGradeProfiles: new FormControl(''),
      confidential: new FormControl(''),
      customerInactive: new FormControl(''),
      serviceType: new FormControl(''),
      motherTounge: new FormControl(''),
      setTypeOfView: new FormControl(this.viewType),
      noPaymentOffer: new FormControl(null),
      noServiceByEmp: new FormControl(''),
      autoMailUpdate: new FormControl(''),
      paymentFrom: new FormControl(''),
      paymentTo: new FormControl(''),
      mobileLogIn: new FormControl(null),
      confidentialGrade: new FormControl(''),
      educationCategory: new FormControl(''),
      noDataIndication: new FormControl(''),
      renewal: new FormControl(''),
      chkKmplexperiry: new FormControl(''),
      havingProfile: new FormControl(''),
      logoutId: new FormControl(null),
      propertyFrom: new FormControl(''),
      propertyTo: new FormControl(''),
      Nconfidential: new FormControl(null),
    });
  }

  reset() {
    this.myProfileForm.patchValue({
      applicationStatus: [{id: 54, value: "Active"}],
      profileOwner: this.owner.filter(emp => emp.id === this.loginData['employeeID']),
      caste: [{id: 402, value: "Kamma"}],
      gender: 0,
      typeOfProfile: null,
      dateTypeLogin: 1,
      domacile: null,
      verifiedContacts: null,
      websiteBlocked: null,
      noPaymentOffer: null,
      mobileLogIn: null,
      logoutId: null,
      setTypeOfView: 1,
      profileID: '',
      marital: '',
      branch: '',
      dateOfRegFrom: '',
      dateOfRegTo: '',
      assignedFrom: '',
      assignedTo: '',
      firstName: '',
      surName: '',
      fatherName: '',
      motherName: '',
      dateLoginFrom: '',
      dateLoginTo: '',
      secondaryOwner: '',
      previousOwner: '',
      highConfidential: '',
      nxGradeProfiles:'',
      confidential: '',
      customerInactive: '',
      serviceType: '',
      motherTounge: '',
      noServiceByEmp: '',
      autoMailUpdate: '',
      paymentFrom: '',
      paymentTo: '',
      confidentialGrade: '',
      educationCategory: '',
      noDataIndication: '',
      renewal: '',
      chkKmplexperiry: '',
      havingProfile: '',
      propertyFrom: '',
      propertyTo: ''
    });
    this.confiGrade = false;
  }

  loadBasicMasterData() {
    this.loginDataStore.getStoreData('empData')
    .then((dataRes: any) => {
      this.loginData = JSON.parse(dataRes);
      // console.log(this.loginData)
      this.loadEmpDependOnBranch()
      this.service.loadMasterDataWithId('ConfidentailGrade', this.loginData['employeeID']).then((res) => {
        this.confidentialGrades = res['result'];
      });
    })

    this.service.loadMasterData('ApplicationStatus').then((response) => {
      this.applicationStatus = response['result'];
      this.myProfileForm.patchValue({applicationStatus: [{id: 54, value: "Active"}]})
    })
    .catch((err) => console.error(err));

    this.service.loadMasterData('MaritalStatusSearch').then((response) => {
      this.marital = response['result'];
    }).catch((err) => console.log(err));

    this.service.loadMasterDataWithId('StateLocation', '408,409,410,411').then((empResult) => {
      this.branchList = empResult['result'];
      // this.myProfileForm.patchValue({branch: this.branchList.filter(emp => emp.id === this.loginData['branch'])})
      // const branchID = this.branchList.filter(emp => emp.id === this.loginData['branch'])
      // this.branchStrList.push(branchID[0].id)
    });

    this.service.loadMasterData('Caste').then((response) => {
      this.caste = response['result'];
      this.myProfileForm.patchValue({caste: [{id: 402, value: "Kamma"}]})
    }).catch((err) => console.log(err));

    this.service.loadMasterData('MotherTongueSearch').then((response) => {
      this.motherTongue = response['result'];
    })
    .catch((err) => console.error(err));

    this.service.loadMasterData('HighestEducation').then((res) => {
      this.educationCategories = res['result'];
    })
    .catch((err) => console.error(err));

    this.service.loadMasterData('NoData').then((res) => {
      this.noDataList = res['result'];
    })
    .catch((err) => console.error(err));
  }

  loadEmpDependOnBranch() {
    // this.service.loadMasterDataWithId('ProfileOwnerbyBranch', this.loginData['branch']).then((response) => {
    //   this.owner = response['result'];
    //   this.myProfileForm.patchValue({profileOwner: this.owner.filter(emp => emp.id === this.loginData['employeeID'])})
    // })
    // .catch((err) => console.error(err));
    this.service.loadMasterData('ProfileOwner',).then((response) => {
      this.owner = response['result'];
      // this.myProfileForm.patchValue({profileOwner: this.owner.filter(emp => emp.id === this.loginData['employeeID'])})
    })
    .catch((err) => console.error(err));
  }

  onBranchItemSelect(event) {
    this.owner = [];
    this.branchStrList.push(event.id);
    this.service
      .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.branchStrList))
      .then((empResult) => {
        this.owner = empResult['result'];
        this.myProfileForm.patchValue({profileOwner: '' })

      })
  }

  onBranchItemDeSelect(event) {
    let index = this.branchStrList.indexOf(event.id);
    this.branchStrList.splice(index, 1);
    this.owner = [];
    if (this.branchStrList.length > 0) {
      this.service
      .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.branchStrList))
      .then((empResult) => {
        this.owner = empResult['result'];
        this.myProfileForm.patchValue({profileOwner: '' })
      })
    } else {
      this.service.loadMasterData('ProfileOwner',).then((response) => {
        this.owner = response['result'];
        // this.myProfileForm.patchValue({profileOwner: this.owner.filter(emp => emp.id === this.loginData['employeeID'])})
      })
      .catch((err) => console.error(err));
    }

  }

  onBranchDeSelectAll(event) {
    // this.branchStrList = event;
    this.owner = [];
    this.service.loadMasterData('ProfileOwner',).then((response) => {
      this.owner = response['result'];
      // this.myProfileForm.patchValue({profileOwner: this.owner.filter(emp => emp.id === this.loginData['employeeID'])})
    })
    .catch((err) => console.error(err));
  }
  onBrachItemsSelectAll(event) {
    this.branchStrList = [];
    for (let i = 0; i < event.length; i++) {
      this.branchStrList.push(event[i]['id'])
    }
    this.owner = [];
    this.service
      .loadMasterDataWithId('ProfileOwnerbyBranch', String(this.branchStrList))
      .then((empResult) => {
        this.owner = empResult['result'];
        this.myProfileForm.patchValue({profileOwner: '' })
      })
  }

  onChange(e){
    const item = e.target.value.replace(/\D/g,'')
    this.myProfileForm.patchValue({'profileID': item})
  }

  omit_specialChar_and_char(event) {
    let x = event.which || event.keycode;
    if ((x >= 48 && x <= 57))
      return true;
    else
      return false;
  }

  dateTypeChange(event) {
    if(event.value === 1) {
      this.dateTypeFrom = 'Website Login From';
      this.dateTypeTo = 'Website Login To';
      this.enableDates = true;
    } else if(event.value === 2) {
     this.dateTypeFrom = 'Mobile Login From';
     this.dateTypeTo = 'Mobile Login To';
     this.enableDates = true;
    } else if(event.value === 0) {
     this.dateTypeFrom = 'From';
     this.dateTypeTo = 'To';
     this.enableDates = true;
    } else if(event.value == null) {
      this.enableDates = false;
     }
   }

   clearDate(field) {
    if (field  === 'dateLoginFrom') {
      this.myProfileForm.controls['dateLoginFrom'].reset();
    } else if (field === 'dateLoginTo') {
      this.myProfileForm.controls['dateLoginTo'].reset();
    } else if (field === 'dateOfRegFrom') {
      this.myProfileForm.controls['dateOfRegFrom'].reset();
    } else if (field === 'dateOfRegTo') {
      this.myProfileForm.controls['dateOfRegTo'].reset();
    } else if (field === 'assignedFrom') {
      this.myProfileForm.controls['assignedFrom'].reset();
    } else if (field === 'assignedTo') {
      this.myProfileForm.controls['assignedTo'].reset();
    } else if (field === 'paymentFrom') {
      this.myProfileForm.controls['paymentFrom'].reset();
    } else if (field === 'paymentTo') {
      this.myProfileForm.controls['paymentTo'].reset();
    }
  }

  _convertDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    month.length < 2 ? (month = '0' + month) : month;
    day.length < 2 ? (day = '0' + day) : month;

    return [month, day, year].join('/');
  }

  getMyProfiles(event) {
    this.myProfileReqObj = {
      genderID: this.myProfileForm.value['gender'] ? Number(this.myProfileForm.value['gender']) : null,
      typeofprofileID: this.myProfileForm.value['typeOfProfile'] != null ? Number(this.myProfileForm.value['typeOfProfile']) : null,
      profileid: this.myProfileForm.value['profileID'] ? String(this.myProfileForm.value['profileID']).trim() : null,
      i_Domacile: this.myProfileForm.value['domacile'] ? Number(this.myProfileForm.value['domacile']) : null,
      applicationstatusID: this.myProfileForm.value.applicationStatus &&
      this.myProfileForm.value.applicationStatus.length !== 0
      ? this.myProfileForm.value.applicationStatus.length > 1
        ? String(
          this.myProfileForm.value.applicationStatus.map((val) => {
            return String(val.id);
          })
        )
        : String(this.myProfileForm.value.applicationStatus[0].id)
      : null,
      v_MaritalStatus: this.myProfileForm.value.marital &&
      this.myProfileForm.value.marital.length !== 0
      ? this.myProfileForm.value.marital.length > 1
        ? String(
          this.myProfileForm.value.marital.map((val) => {
            return String(val.id);
          })
        )
        : String(this.myProfileForm.value.marital[0].id)
      : null,
      branchID: this.myProfileForm.value.branch &&
      this.myProfileForm.value.branch.length !== 0
      ? this.myProfileForm.value.branch.length > 1
        ? String(
          this.myProfileForm.value.branch.map((val) => {
            return String(val.id);
          })
        )
        : String(this.myProfileForm.value.branch[0].id)
      : null,
      casteID: this.myProfileForm.value.caste &&
      this.myProfileForm.value.caste.length !== 0
      ? this.myProfileForm.value.caste.length > 1
        ? String(
          this.myProfileForm.value.caste.map((val) => {
            return String(val.id);
          })
        )
        : String(this.myProfileForm.value.caste[0].id)
      : null,
      owneroftheprofileID: this.myProfileForm.value.profileOwner &&
      this.myProfileForm.value.profileOwner.length !== 0
      ? this.myProfileForm.value.profileOwner.length > 1
        ? String(
          this.myProfileForm.value.profileOwner.map((val) => {
            return String(val.id);
          })
        )
        : String(this.myProfileForm.value.profileOwner[0].id)
      : null,
      previousownerID: this.myProfileForm.value.previousOwner &&
      this.myProfileForm.value.previousOwner.length !== 0
      ? this.myProfileForm.value.previousOwner.length > 1
        ? String(
          this.myProfileForm.value.previousOwner.map((val) => {
            return String(val.id);
          })
        )
        : String(this.myProfileForm.value.previousOwner[0].id)
      : null,
      motherTongueID: this.myProfileForm.value.motherTounge &&
      this.myProfileForm.value.motherTounge.length !== 0
      ? this.myProfileForm.value.motherTounge.length > 1
        ? String(
          this.myProfileForm.value.motherTounge.map((val) => {
            return String(val.id);
          })
        )
        : String(this.myProfileForm.value.motherTounge[0].id)
      : null,
      educationCategoryFilter: this.myProfileForm.value.educationCategory &&
      this.myProfileForm.value.educationCategory.length !== 0
      ? this.myProfileForm.value.educationCategory.length > 1
        ? String(
          this.myProfileForm.value.educationCategory.map((val) => {
            return String(val.id);
          })
        )
        : String(this.myProfileForm.value.educationCategory[0].id)
      : null,
      noDataFilter: this.myProfileForm.value.noDataIndication &&
      this.myProfileForm.value.noDataIndication.length !== 0
      ? this.myProfileForm.value.noDataIndication.length > 1
        ? String(
          this.myProfileForm.value.noDataIndication.map((val) => {
            return String(val.id);
          })
        )
        : String(this.myProfileForm.value.noDataIndication[0].id)
      : null,
      havingprofilesID: this.myProfileForm.value.havingProfile &&
      this.myProfileForm.value.havingProfile.length !== 0
      ? this.myProfileForm.value.havingProfile.length > 1
        ? String(
          this.myProfileForm.value.havingProfile.map((val) => {
            return String(val.id);
          })
        )
        : String(this.myProfileForm.value.havingProfile[0].id)
      : null,
      secondaryOwnerFilter: this.myProfileForm.value.secondaryOwner &&
      this.myProfileForm.value.secondaryOwner.length !== 0
      ? this.myProfileForm.value.secondaryOwner.length > 1
        ? String(
          this.myProfileForm.value.secondaryOwner.map((val) => {
            return String(val.id);
          })
        )
        : String(this.myProfileForm.value.secondaryOwner[0].id)
      : null,
      confidentialGrade: this.myProfileForm.value.confidentialGrade &&
      this.myProfileForm.value.confidentialGrade.length !== 0
      ? this.myProfileForm.value.confidentialGrade.length > 1
        ? String(
          this.myProfileForm.value.confidentialGrade.map((val) => {
            return String(val.id);
          })
        )
        : String(this.myProfileForm.value.confidentialGrade[0].id)
      : null,
      serviceTypeID: this.myProfileForm.value.serviceType &&
      this.myProfileForm.value.serviceType.length !== 0
      ? this.myProfileForm.value.serviceType.length > 1
        ? String(
          this.myProfileForm.value.serviceType.map((val) => {
            return String(val.id);
          })
        )
        : String(this.myProfileForm.value.serviceType[0].id)
      : null,
      autoMailerUpdatedProfiles: this.myProfileForm.value['autoMailUpdate'] ? 1 : 0,
      renewal: this.myProfileForm.value['renewal'] ? true : false,
      chkKmplexperiry: this.myProfileForm.value['chkKmplexperiry'] ? true : false,
      employeeServiceFilter: this.myProfileForm.value['noServiceByEmp'] ? 1 : 0,
      mobileAppUsersFilter: this.myProfileForm.value['mobileLogIn'] ? Number(this.myProfileForm.value['mobileLogIn']) : null,
      logoutId: this.myProfileForm.value['logoutId'] ? Number(this.myProfileForm.value['logoutId']) : null,
      paymentFromDate: this.myProfileForm.value['paymentFrom'] ? this._convertDate(this.myProfileForm.value['paymentFrom']) : null,
      paymentToDate: this.myProfileForm.value['paymentTo'] ? this._convertDate(this.myProfileForm.value['paymentTo']) : null,
      paymentOfferFilter: this.myProfileForm.value['noPaymentOffer'] ? Number(this.myProfileForm.value['noPaymentOffer']) : null,
      dorFromdate: this.myProfileForm.value['dateOfRegFrom'] ? this._convertDate(this.myProfileForm.value['dateOfRegFrom']) : null,
      dorTodate: this.myProfileForm.value['dateOfRegTo'] ? this._convertDate(this.myProfileForm.value['dateOfRegTo']) : null,
      assigneddatefromdate: this.myProfileForm.value['assignedFrom'] ? this._convertDate(this.myProfileForm.value['assignedFrom']) : null,
      assigneddatetodate: this.myProfileForm.value['assignedTo'] ? this._convertDate(this.myProfileForm.value['assignedTo']) : null,
      loginFilter: this.myProfileForm.value['dateTypeLogin'] != null ? Number(this.myProfileForm.value['dateTypeLogin']) : null,
      loginFromDate: this.myProfileForm.value['dateLoginFrom'] ? this._convertDate(this.myProfileForm.value['dateLoginFrom']) : null,
      loginToDate: this.myProfileForm.value['dateLoginTo'] ? this._convertDate(this.myProfileForm.value['dateLoginTo']) : null,
      firstName: this.myProfileForm.value['firstName'] ? this.myProfileForm.value['firstName'].trim() : null,
      surname: this.myProfileForm.value['surName'] ? this.myProfileForm.value['surName'].trim() : null,
      fatherName: this.myProfileForm.value['fatherName'] ? this.myProfileForm.value['fatherName'].trim() : null,
      motherName: this.myProfileForm.value['motherName'] ? this.myProfileForm.value['motherName'].trim() : null,
      confidential: this.myProfileForm.value['confidential'] ? true : false,
      highConfidential: this.myProfileForm.value['highConfidential'] ? true : false,
      SuperHighConfidential: this.myProfileForm.value['nxGradeProfiles'] ? true : false,
      verfiedcontacts: this.myProfileForm.value['verifiedContacts'] != null ? Number(this.myProfileForm.value['verifiedContacts']) : null,
      verifiedEmail: this.myProfileForm.value['emailVerifiedContacts'] != null ? Number(this.myProfileForm.value['emailVerifiedContacts']) : null,
      websiteBlocked: this.myProfileForm.value['websiteBlocked'] ? Number(this.myProfileForm.value['websiteBlocked']) : null,
      noActivity: this.myProfileForm.value['customerInactive'] ? 1 : 0,
      intTableType: this.myProfileForm.value['setTypeOfView'] ? Number(this.myProfileForm.value['setTypeOfView']) : null,
      propertyValuefrom: this.myProfileForm.value['propertyFrom'] ? this.myProfileForm.value['propertyFrom'] : null,
      propertyValueto: this.myProfileForm.value['propertyTo'] ? this.myProfileForm.value['propertyTo'] : null,
      IsNConfidential: this.myProfileForm.value['Nconfidential'],
      pagefrom: 1,
      pageto: 200,
      empid: this.loginData['employeeID']

    }

    this.scrollDown = false;
    this.loadedAllData = false;
    this.myProfiles = [];
    this.allMyProfiles = [];
    this.LoaderComponent = LoaderComponent;
    this.service.getMyProfiles(this.myProfileReqObj).then((res) => {
      if (res['statusCode'] === 200) {
        this.LoaderComponent = '';
        if (this.slideshowOrGrid == "grid") {
          this.expanded = false;
          this.myProfiles = res['result'];
          this.converLakhsToCrores(this.myProfiles);
          this.allMyProfiles = res['result'];
          this.formValue = this.myProfiles[0];
          this.lastvalue = this.allMyProfiles[this.allMyProfiles.length-1]
          this.gridType2 = 'com2';
          this.myProfileGrid = true;          
          this.prepareHeaders();
        } else if(this.slideshowOrGrid == "slide") {
          const myProfiles = res['result'];
          const dialogRef = this.dialog.open(OldSlideShowComponent, {
            maxWidth: '90vw',
            width: '100%',
            height: '91%',
            disableClose: true,
            data: {
              formValue: myProfiles[0],
              mode: 'myProfile',
              display: res['result'],
              reqObj: this.myProfileReqObj,
              DORTable: true
            }
          })

        }
      } else {
        this.LoaderComponent = '';
        this.responseMessage = res['message']
        this.alertModal.show()
        setTimeout(() => {
          this.alertModal.hide();
        }, 5000);
      }
    })
  }

  loadMore() {
    if(this.myProfileReqObj['pageto'] < this.formValue['totalRows']) {
      this.myProfileReqObj['pagefrom'] = this.myProfileReqObj['pageto'] + 1;
      this.myProfileReqObj['pageto'] = this.myProfileReqObj['pageto'] + 100;
      this.LoaderComponent = LoaderComponent;
      this.myProfiles = [];
      this.service.getMyProfiles(this.myProfileReqObj).then((res) => {
        if (res['statusCode'] === 200) {
          this.LoaderComponent = '';
          this.expanded = false;
          let count = res['result'].length;
          for (let i = 0; i < count; i++) {
            this.allMyProfiles.push(res['result'][i])
          }
          this.myProfiles = this.allMyProfiles;
          this.converLakhsToCrores(this.myProfiles);
          this.formValue = res['result'][0];
          this.lastvalue = this.allMyProfiles[this.allMyProfiles.length-1]
          this.gridType2 = 'com2';
          this.prepareHeaders();
          this.loadedAllData = this.myProfiles[0]['totalRows'] === this.myProfiles.length ? true : false;
        } else {
          this.LoaderComponent = '';
        }
      })
    } else if (this.myProfileReqObj['pageto'] >= this.formValue['totalRows']) {
      this.loadedAllData = true;
    }
    this.scrollDown = true;
  }

  prepareHeaders() {
    this.totalFields = [
      { name: 'Profile ID', id: 'profileID' },
      { name: 'Surname', id: 'lastName' },
      { name: 'First Name', id: 'firstName' },
      { name: 'Gender', id: 'Gender' },
      { name: 'Caste', id: 'caste' },
      { name: 'E-Category', id: 'EducationCategory' },
      { name: 'Salary', id: 'Salary' },
      { name: 'Property', id: 'Property' },
      { name: 'Registration Date', id: 'RegistrationDate' },
      { name: 'Marital Status', id: 'MaritalStatus' },
      { name: 'Profile Owner', id: 'profileOwnername' },
      { name: 'Secondary Owner', id: 'SecondaryProfileOwner' },
      { name: 'Marketing Ticket', id: 'ticketID' },
      { name: 'Mob login count', id: 'mobileLoginCount' },
      { name: 'Web login count', id: 'websiteLoginCount' },
      // { name: 'Otherside Employee', id: 'toemp' },
      // { name: 'Otherside Ticket', id: 'toticketid' },
      // { name: 'Options', id: 'options' }
      // { name: 'To Status', id: 'toticketStatusIDb'}
    ]
    this.matchedHeaders = [
      { name: 'Profile ID', id: 'profileID' },
      { name: 'Surname', id: 'lastName' },
      { name: 'First Name', id: 'firstName' },
      { name: 'Gender', id: 'Gender' },
      { name: 'Caste', id: 'caste' },
      { name: 'E-Category', id: 'EducationCategory' },
      { name: 'Salary', id: 'Salary' },
      { name: 'Property', id: 'Property' },
      { name: 'Registration Date', id: 'RegistrationDate' },
      { name: 'Marital Status', id: 'MaritalStatus' },
      { name: 'Profile Owner', id: 'profileOwnername' },
      { name: 'Secondary Owner', id: 'SecondaryProfileOwner' },
      { name: 'Marketing Ticket', id: 'ticketID' },
      { name: 'Mob login count', id: 'mobileLoginCount' },
      { name: 'Web login count', id: 'websiteLoginCount' },
      // { name: 'Otherside Employee', id: 'toemp' },
      // { name: 'Otherside Ticket', id: 'toticketid' },
      // { name: 'Options', id: 'options' }
      // { name: 'To Status', id: 'toticketStatusIDb'}
    ]
    this.headers = [
      'serial', 'profileID', 'lastName', 'firstName', 'Gender', 'caste', 'EducationCategory', 'Salary', 'Property', 
      'RegistrationDate', 'MaritalStatus', 'profileOwnername', 'SecondaryProfileOwner', 'ticketID', 'mobileLoginCount',
      'websiteLoginCount'
    ]
  }

  openGradeSelection(event) {
    this.confiGrade = event.checked;
  }
  

  converLakhsToCrores(records){
    for(let record of records){
      let lakhs = record.Property; 
      if(Number(lakhs) > 0)
        record.Property = this.propertyLakhsToCroresConversion(record.Property);
    }
  }

  propertyLakhsToCroresConversion(lakhsValue){ 
    let tempPropertyValue: number = lakhsValue;
    let propertyString: any;
    if(tempPropertyValue < 100){
      if(tempPropertyValue < 2)
         propertyString =  tempPropertyValue+' Lakh';
      else
        propertyString =  tempPropertyValue+' Lakhs';
    }      
    else{
      let covertedValue = tempPropertyValue / 100;
      if(covertedValue < 2){
        propertyString = covertedValue+' Crore';
      }
      else
        propertyString = covertedValue+' Crores';
    }
    return propertyString
  }


}
